<template>
  <section id="formulario" class="bg-[#57af4e] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6">

        <div class="w-full py-6">
          <h1 class="plex-semibold text-xl text-gray-800">VISITANTE</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" placeholder="DNI / Pasaporte" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="dni" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Empresa / Profesional</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Empresa" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="empresa" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.cargo">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione el cargo" :options="cargos" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="cargo" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País (Residencia)</label>
            <Field name="paisResidencia" v-slot="{ handleChange, handleBlur, value, errors }"
              v-model="formData.paisResidencia">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }"
                placeholder="País de residencia" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="paisResidencia" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provincia" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text" placeholder="Ingrese su provincia o estado" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provinciaEstado" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id == '+54'">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.localidad">
              <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione la localidad" class="input-base" :options="localidades"
                optionLabel="descripcion"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="localidad" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisResidencia?.id != '+54'">
            <label class="block mb-1">Localidad / Ciudad</label>
            <Field name="localidadCiudad" v-slot="{ field, errors }" v-model="formData.localidadCiudad">
              <InputText v-bind="field" type="text" placeholder="Ingrese su localidad o ciudad" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="localidadCiudad" />
              </span>
            </Field>
          </div>

        </div>


        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Rubro</label>
            <Field name="rubro" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubro">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione el rubro" :options="rubros" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="rubro" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2" v-if="formData.rubro?.id === 9">
            <label class="block mb-1">Especifique el rubro</label>
            <Field name="otroRubro" v-slot="{ field, errors }" v-model="formData.otroRubro">
              <InputText v-bind="field" type="text" placeholder="Especifique su rubro" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="otroRubro" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2" v-if="formData.rubro?.id !== 9">
            <label class="block mb-1">¿A qué expositor viene a visitar en la expo?</label>
            <Field name="expositorVisita" v-slot="{ field, errors }" v-model="formData.expositorVisita">
              <InputText v-bind="field" type="text" placeholder="Ingrese a que expositor viene a visitar"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="expositorVisita" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" v-if="formData.rubro?.id === 9">
          <div class="w-full px-2 ">
            <label class="block mb-1">¿A qué expositor viene a visitar en la expo?</label>
            <Field name="expositorVisita" v-slot="{ field, errors }" v-model="formData.expositorVisita">
              <InputText v-bind="field" type="text" placeholder="Ingrese a que expositor viene a visitar"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="expositorVisita" />
              </span>
            </Field>
          </div>
        </div>


        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';


import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';
import jsonCargos from '@/data/cargos.json';
import jsonRubros from '@/data/rubros.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";


interface Pais extends StringIdLabelEntity { }
interface Provincia extends IdLabelEntity { }
interface Localidad extends IdLabelEntity { }


interface Cargo extends IdLabelEntity { }
interface Rubro extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      paises: jsonCountries as Pais[],
      provincias: jsonProvincias as Provincia[],
      localidades: jsonLocalidades as Localidad[],
      isSubmitting: false,
      cargos: [] as Cargo[],
      rubros: [] as Rubro[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        empresa: '',
        mail: '',
        paisResidencia: { "id": "+54", "descripcion": "Argentina" } as Pais,
        localidad: undefined as unknown as Localidad,
        localidadCiudad: '',
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        cargo: undefined as unknown as Cargo,
        rubro: undefined as unknown as Rubro,
        otroRubro: '',
        expositorVisita: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        empresa: yup.string().required('Ingrese la empresa').min(2, 'Al menos 3 letras'),
        cargo: yup.mixed().required('Seleccione el cargo'),
        rubro: yup.mixed().required('Seleccione el rubro'),
        otroRubro: yup.string().test('validacion-otro-rubro', 'Debes ingresar el rubro o seleccionar uno de la lista', function (value) {
          const rubroSelected = this.parent.rubro;
          if (rubroSelected?.id === 9 && !value) {
            return false;
          }
          return true;
        }),

        provincia: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidad: yup.mixed().test('validacion-localidad-argentina', 'Seleccione la localidad', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', 'Ingrese la provincia/estado', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidadCiudad: yup.string().test('validacion-localidad-otro', 'Ingrese la localidad/ciudad', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),
      });
    }
  },
  watch: {
    'formData.rubro.id'(newValue) {
      if (newValue !== 9) {
        this.formData.otroRubro = '';
      }
    },
    'formData.provincia.id'(newValue) {
      if (newValue) {
        this.localidades = jsonLocalidades;
        this.localidades = this.localidades.filter((localidad: Localidad) => localidad.id === newValue);
      }
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "¡Ya se acreditó con este DNI / Pasaporte!<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }

      acreditadoExistente = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "mail=" + encodeURIComponent(this.formData.mail));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "¡Ya se acreditó con este email!<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }
      this.isSubmitting = true;

      let acreditado: Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 2252 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.empresa = this.formData.empresa;
      acreditado.mail = this.formData.mail;
      acreditado.cargo = this.formData.cargo.descripcion;
      acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.modificado = SAVE; // SAVE
      acreditado.cantidad = 1;
      acreditado.notificar = true;

      acreditado.dato5 = this.formData.paisResidencia.descripcion;

      if (this.formData.paisResidencia?.id == "+54") {
        acreditado.dato6 = this.formData.provincia?.descripcion;
        acreditado.dato18 = this.formData.localidad?.descripcion;
      } else {
        acreditado.dato6 = this.formData.provinciaEstado;
        acreditado.dato18 = this.formData.localidadCiudad;
      }

      acreditado.dato8 = this.formData.rubro.descripcion;
      acreditado.dato15 = this.formData.otroRubro;

      acreditado.dato20 = this.formData.expositorVisita;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Hemos recibido sus datos de acreditación con éxito.<br/>Le enviamos un código QR al mail indicado para agilizar su ingreso al evento. <br/><br/>Si tiene problemas para recibir el correo puede presentarse con sun DNI.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://fimar.com.ar";
        });

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.cargos = jsonCargos;
    this.rubros = jsonRubros;
  }
});
</script>
